module.exports = __webpack_public_path__ + "img/dracula-24.12c7d9e0.jpg";